import { useEffect } from "react";
import useAPIs from "./useAPIs";
import WishToaster from "../components/WishToaster";

const useAnalysis = () => {
  const { apiError, postData } = useAPIs();

  useEffect(() => {
    console.log(apiError, "apiError");
    if (apiError) WishToaster({ toastType: "error", toastMessage: apiError });
  }, [apiError]);

  const callApiByType = (apiType, payload, onSuccess, onError) => {
    switch (apiType) {
      case "firstOrderTrend":
        return postData("/reports/first-order-trend", payload, onSuccess, onError);
      case "reOrderTrend":
        return postData("/reports/re-order-trend", payload, onSuccess, onError);
      case "rankTrend":
        return postData("/reports/rank-trend", payload, onSuccess, onError);
      case "volumeTrend":
        return postData("/reports/volume-trend", payload, onSuccess, onError);
      case "ordersTrend":
        return postData("/reports/order-trend", payload, onSuccess, onError);
      case "topRetailers":
        return postData("/reports/my-team-top-retail-leaders", payload, onSuccess, onError);
      default:
        throw new Error(`Invalid API type: ${apiType}`);
    }
  };

  const getTopleaders = (payload, onSuccess, onError) => {
    postData(
      `/reports/my-team-top-leaders`,
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
        WishToaster({
          toastMessage: error,
          toastType: "error",
        });
      }
    );
  };

  const getMyCoreTeamDashboard = (payload, onSuccess, onError) => {
    postData(
      `/reports/core-team-detailed-dashboard`,
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
        WishToaster({
          toastMessage: error,
          toastType: "error",
        });
      }
    );
  };
  const getMyCoreTeamDashboardSummary = (payload, onSuccess, onError) => {
    postData(
      `/reports/core-team-dashboard-summary`,
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
        WishToaster({
          toastMessage: error,
          toastType: "error",
        });
      }
    );
  };
  const searchDistributor = (payload, onSuccess, onError) => {
    postData(
      `/enrollment/search-core-team-members`,
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
        WishToaster({
          toastMessage: error,
          toastType: "error",
        });
      }
    );
  };
  const getOutgoingRequests = (payload, onSuccess, onError) => {
    postData(
      `/enrollment/get-pending-request-core-memeber`,
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
        WishToaster({
          toastMessage: error,
          toastType: "error",
        });
      }
    );
  };
  const getIncomingRequests = (payload, onSuccess, onError) => {
    postData(
      `/enrollment/get-pending-accept-request-core-memeber`,
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
        WishToaster({
          toastMessage: error,
          toastType: "error",
        });
      }
    );
  };
  const sendCoreTeamRequest = (payload, onSuccess, onError) => {
    postData(
      `/enrollment/send-request-core-team-member`,
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
        WishToaster({
          toastMessage: error,
          toastType: "error",
        });
      }
    );
  };
  const removeCoreTeamMember = (payload, onSuccess, onError) => {
    postData(
      `/enrollment/remove-request-core-team-memeber`,
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
        WishToaster({
          toastMessage: error,
          toastType: "error",
        });
      }
    );
  };
  const declineRequestCoreTeamMember = (payload, onSuccess, onError) => {
    postData(
      `/enrollment/decline-request-core-team-memeber`,
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
        WishToaster({
          toastMessage: error,
          toastType: "error",
        });
      }
    );
  };
  const acceptRequestCoreTeamMember = (payload, onSuccess, onError) => {
    postData(
      `/enrollment/update-accept-request-core-team-memeber`,
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
        WishToaster({
          toastMessage: error,
          toastType: "error",
        });
      }
    );
  };
  const cancelRequestCoreTeamMember = (payload, onSuccess, onError) => {
    postData(
      `/enrollment/cancel-request-core-team-memeber`,
      payload,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        onError && onError(error);
        WishToaster({
          toastMessage: error,
          toastType: "error",
        });
      }
    );
  };
  return {
    callApiByType,
    getTopleaders,
    getMyCoreTeamDashboard,
    searchDistributor,
    getMyCoreTeamDashboardSummary,
    getOutgoingRequests,
    getIncomingRequests,
    sendCoreTeamRequest,
    removeCoreTeamMember,
    declineRequestCoreTeamMember,
    acceptRequestCoreTeamMember,
    cancelRequestCoreTeamMember,
  };
};

export default useAnalysis;
